import { mapGetters } from 'vuex'
import Modal from 'com/Modal'

export default {
  computed: {
    ...mapGetters(['location', 'permission']),
    hasHKLimitedPermission() {
      return (
        this.permission.includes('hkStockQuoteLv1Limited') ||
        this.permission.includes('hkStockQuoteLv2Limited') ||
        this.permission.includes('hkStockQuoteLv2AreaLimited')
      )
    },
    hasUSLimitedPermission() {
      return this.permission.includes('usStockQuoteLimited')
    }
  },
  watch: {
    hasHKLimitedPermission(limited) {
      if (limited) this.showHKLevelChangeAlert()
    },
    hasUSLimitedPermission(limited) {
      if (limited) this.showUSLevelChangeAlert()
    }
  },
  methods: {
    showHKLevelChangeAlert() {
      const hkAlertTip = this.$t('hk-level.hk-level-tip')
      const hkAlertTitle = this.$t('hk-level.hk-level-down-title')
      const hkAlertClick = this.$t('hk-level.hk-level-click')
      const hkAlertContent = this.$t('hk-level.hk-level-down-content')
      const hkAlertBody = `<div>${hkAlertTitle}</div><div>${hkAlertClick} <img style="vertical-align: -15%" src="/static/img/level-2.svg"/> ${hkAlertContent}</div>`

      Modal.open({
        title: hkAlertTip,
        content: hkAlertBody,
        cancelButton: false
      })
    },
    showUSLevelChangeAlert() {
      Modal.open({
        title: this.$t('tip-title'),
        content: this.$t('usStockQuoteLimited-alert'),
        cancelButton: false
      })
    }
  }
}
